// 以下代码是一些常量命名 --------------------
// post请求的 Content-Type
import Fingerprint from 'fingerprintjs';

var qs = require('qs');

var axios = require('axios');

// var axiosFinally = require("promise.prototype.finally");

var md5 = require('md5');


var copy = require('./extend');

var errCode = require('./code');



var reqApplication = 'application/x-www-form-urlencoded; charset=UTF-8';

var header = {};

import {
    Promise
} from "es6-promise";
window.Promise = Promise;
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
//声明一个数组用于存储每个ajax请求的取消函数和ajax标识
var pending = [];
//初始化取消请求的构造函数
var getCancelToken = axios.CancelToken
var removePending = (config, f) => {
    var flagUrl = config.url + '&' + config.method
    if (pending.indexOf(flagUrl) !== -1) {
        if (f) {
            f()
        }
    } else {
        if (f) {
            pending.push(flagUrl)
        }
    }
}
/**
* 解析字符串，将key=main_choose_grade_id&value=3这样的字符串转换成一个带有=前键值的对象方法
* param     {String} str   字符串
* @return   {Object} 返回str转换后的对象
*/
function parseStrToObject(str){
    var changeObject = {}, arr = [];
    //将字符串以&为分割点转换成数组
    arr = str.split("&");
    //循环字符串转换为了对应键值的对象,字符串必须是ey=main_choose_grade_id&value=3格式
    for(var i = 0; i < arr.length; i ++) {
      changeObject[decodeURIComponent(arr[i].split("=")[0])] = decodeURIComponent((arr[i].split("="))[1]);
    }
    return changeObject;
}
axios.interceptors.request.use((res) => {
    if (res.method != 'options') {
        // res.cancelToken = new getCancelToken((c) => {
        //     removePending(res, c);
        // });
        var cancelGroupName = '',
            formType = 'formdata'
        if (res.method === 'post') {
            // 字符串形式转换为对象
            if ((typeof res.data == 'string') && res.data) {
                res.data = parseStrToObject(res.data)
                formType = ''
            }
            // post请求ajax取消函数配置
            if (res.data && res.data.cancelGroupName) {
              cancelGroupName = res.data.cancelGroupName
            }
            if (!formType) {
                res.data = qs.stringify(res.data)
            }
        }
        if(res.method === 'get'){
             // get请求ajax取消函数配置
            if (res.params && res.params.cancelGroupName) {
              cancelGroupName = res.params.cancelGroupName
            }
        }
        if (cancelGroupName) {
          if (axios[cancelGroupName] && axios[cancelGroupName].cancel) {
            axios[cancelGroupName].cancel()
          }
          res.cancelToken = new getCancelToken(c => {
            axios[cancelGroupName] = {}
            axios[cancelGroupName].cancel = c
          })
        }
    }
    for (var i in header) {
        res.headers[i] = header[i];
    }
    res.headers['Server-Origin'] = 'js-sdk';
    res.headers['device-id'] = _util.createdDeviceId()
    res.headers['ver-num'] = process.env.SET_VERSION;
    // console.log(res.data)
    return res
})
axios.interceptors.response.use((res) => {
    var flagUrl = res.config.url + '&' + res.config.method;
    if (pending.indexOf(flagUrl) !== -1) {
        pending.splice(pending.indexOf(flagUrl), 1)
    }
    return res.data
})

var _util = {
    setHeader: function (headers) {
        header = headers;
    },
    /*
    * @discribe 用于merge传入对象和身份对象UserInfo
    * @method getParams
    * @param [userInfo, params]
    * @return {Object} 返回一个从新整合的对象
    * TODO 未处理对象的字段目前暂未定义完全
    * */
    getParams: function (params) {
        return copy.extend(true, {}, params)
    },
    /*
    * @discribe 创建deviceId
    * @method createdDeviceId
    * @param Null
    * @return {String} 返回一个字符串
    * TODO 未处理对象的字段目前暂未定义完全
    * */
    createdDeviceId() {
        return new Fingerprint().get();
    },
    /*
    * @discribe 用于对传入字段进行MD5加密
    * @method md5Code
    * @param {message}
    * @return {String} 返回MD5加密后的字符串
    * TODO 未处理对象的字段目前暂未定义完全
    * */
    md5Code: function (message) {
        return md5(message)
    },
    /*
    * @discribe 手机号的验证，需要传入手机号和地区
    * 不同地区的手机号，验证方式也不相同
    * @method validPhone
    * @param [phone, area]
    * @return {Boolean} 返回一个布尔值
    * TODO 未处理对象的字段目前暂未定义完全
    * */
    validPhone: function (phone, area) {
        if (/^(\+|0)?86$/.test(area)) {
            // 大陆
            return /^1[3456789]\d{9}$/.test(phone)
        } else {
            // 香港
            return /^\d{8,11}$/.test(phone)
        }
        return true
    },
    /*
    * @discribe 用于验证传入的数据中是否存在不是必填字段传的空，如果非必填字段传空，删除掉
    * @method validEmptyKey
    * @param {params}所有字段对象 {notValid}对象中无需验证的字段例如：phone字段是必填字段在其他的方法中验证过了
    * @return {Object} 返回一个从新处理的对象
    * TODO 未处理对象的字段目前暂未定义完全
    * */
    validEmptyKey: function (params, notValid) {
        var obj = copy.extend(true, {}, params);
        for (var i in obj) {
            if (notValid.indexOf(i) > -1) {
                continue;
            } else {
                if (obj[i] === '') {
                    delete obj[i];
                }
            }
        }
    },
    /*
    * @discribe 获取
    * @method getCode
    * @param {resolver} 初始化对象的回调函数
    * @return {Object} 返回一个Promise对象
    * TODO 未处理对象的字段目前暂未定义完全
    * */
    getCode: function (code) {
        return (errCode[code]);
    },
    /*
    * @discribe axios的get方法
    * @method axiosGet
    * @param {res} 请求的url {params} 请求参数
    * @return {Promise} 返回一个Promise对象
    * TODO 未处理对象的字段目前暂未定义完全
    * */
    axiosGet: function (url, params) {
        axios.get(url, {
            params: params.data ? params.data : {},
        }).then(function (res) {
            params.success ? params.success(res) : function (res) {
            }
            params.complete ? params.complete(res) : function (complete) {
            }
        }).catch(function (fail) {
            params.fail ? params.fail(fail) : function (fail) {
            }
            params.complete ? params.complete(fail) : function (fail) {
            }
        })
    },
    /*
    * @discribe axios的post方法
    * @method axiosPost
    * @param {res} 请求的url {params} 请求参数
    * @return {Promise} 返回一个Promise对象
    * TODO 未处理对象的字段目前暂未定义完全
    * */
    axiosPost: function (url, params, type, headers) {
        var data = type == 'formdata' ? params.data : qs.stringify(params.data)
        axios.post(url, data, {
            headers: {
                'Content-Type': headers || reqApplication
            }
        }).then(function (res) {
            params.success ? params.success(res) : function (res) {
            }
            params.complete ? params.complete(res) : function (res) {
            }
        }).catch(function (fail) {
            params.fail ? params.fail(fail) : function (fail) {
            }
            params.complete ? params.complete(fail) : function (fail) {
            }
        })
    },
    /*
    * @discribe 验证必填字段是否为空。
    * @method validInfo
    * @param {res} 请求的url
    * @return {Boolean} 返回一个布尔值作为对象信息的验证
    * TODO 未处理对象的字段目前暂未定义完全
    * */
    validInfo: function (info, validKeyArr) {
        var len = validKeyArr.length;
        for (var i = 0; i < len; i++) {
            if (!info[validKeyArr[i]]) return true
        }
        return false;
    },
    /*
   * @discribe 验证密码是否符合规则。
   * @method validatePwd
   * @param {pwd} 传入的密码
   * @return {Boolean} 返回一个布尔值作为对象信息的验证
   * */
    validPwd: function (pwd) {
        var len = pwd.length
        var patten = /[]/
        if (len < 6 || len > 16) {
            return false
        }
        if (/^\d*$/g.test(pwd)) {
            return false
        }
        if (/\s/g.test(pwd)) {
            return false
        }
        if (/^[a-zA-Z]*$/g.test(pwd)) {
            return false
        }
        if (!/[0-9A-Za-z]/.test(pwd)) {
            return false
        }
        return true
    },
    /*
    * @discribe 验证参数是否不为空。
    * @method validNotEmpty
    * @param {data} 需要验证的对象
    * @return {Boolean} 返回一个布尔值作为对象信息的验证
    * */
    validNotEmpty: function (data) {
        if (typeof data == 'object') {
            if (!Object.keys(data).length) {
                return false
            }
            return true
        }
        if (typeof data == 'string') {
            if (data == '') {
                return false
            }
            return true
        }
        if (typeof data == 'Number') {
            if (data.length == 0) {
                return false
            }
            return true
        }
    },
    /*
    * @discribe 验证是否是一个数字
    * @method validNum
    * @param {data} 需要验证的对象
    * @return {Boolean} 返回一个布尔值作为对象信息的验证
    * */
    validNum: function (num) {
        var a = /^\d/g;
        return a.test(num);
    },
    /*
    * @discribe 对字符串去空格
    * @method trim
    * @param {str} 需要验证的对象
    * @return {String} 返回一个处理后的字符串
    * */
    trim: function (str) {
        if (String.prototype.trim) {
            return str.trim();
        } else {
            return str.replace(/^\s+|\s+$/g, "");
        }
    },
    /* @discribe 验证验证码是否合法
    * @method validNum
    * @param {data} 需要验证的对象
    * @return {Boolean} 返回一个布尔值作为对象信息的验证
    * */
    validVCode: function (code) {
        var a = /^\d{6}$/g;
        return a.test(code);
    },
    /* @discribe 验证验证码是否合法
    * @method validResHeader
    * @param {data} 全局变量中的header对象
    * @return {Boolean} 返回一个布尔值作为对象信息的验证
    * */
    validResHeader: function () {
        var headerArr = ['client-id']
        for (var i = 0; i < headerArr.length; i++) {
            var item = headerArr[i]
            if (!header[item]) {
                return false
            }
        }
        return true
    },
    validEmpty: function (str) {
        return /^\s*$/.test(str) || str.length == 0
    },
    axios: axios
}

module.exports = _util;



// WEBPACK FOOTER //
// ./src/_util.js